import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getOrganizationGradesQuery,
  getOrganizationSubjectsQuery,
  getOrganizationSubjectGroupsQuery,
  getOrganizationSubjectsWithIconQuery,
  getOrganizationSubjectsWithSubjectGroupsQuery,
} from "./OrganizationQueries";

export const getOrganizationSubjectGroupsFromCache = ({ id, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectGroupsQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationGradesFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationGradesQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getOrganizationSubjectsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getOrganizationSubjectsWithSubjectGroupsFromCache = ({
  id,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsWithSubjectGroupsQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getOrganizationSubjectsWithIconFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsWithIconQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};
